import React from 'react';
import {
  StyledTitle, StyledButton,
  StyledButtonsWrapper, StyledInput,
  StyledWrapper,
} from './QuantityComponent.style';

export default function QuantityComponent(props) {
  const {
    style: { body, button, title },
    label,
    maxQuantity,
    minQuantity,
    onClickNextButton,
    onClickPrevButton,
    quantity,
    width='100%'
  } = props;

  const buttonStyles = {
    ...title,
    borderColor: button.backgroundColor,
    color: body.color,
    backgroundColor: body.backgroundColor,
  };

  return (
    <StyledWrapper style={{width: width}}>
      {label && (
        <StyledTitle style={body}>
          {label}
        </StyledTitle>
      )}

      <StyledButtonsWrapper data-testid="quantity-input">
        <StyledButton
          aria-label="decrease"
          type="button"
          onClick={onClickPrevButton}
          customStyles={buttonStyles}
          disabled={quantity <= minQuantity}
        />

        <StyledInput
          name="Quantity"
          type="text"
          value={quantity}
          style={{ ...body, ...{ borderColor: body.backgroundColor } }}
          readOnly
        />

        <StyledButton
          aria-label="increase"
          data-testid="quantity-increase-button"
          type="button"
          onClick={onClickNextButton}
          customStyles={buttonStyles}
          disabled={quantity >= maxQuantity}
        />
      </StyledButtonsWrapper>
    </StyledWrapper>
  );
}
